export default __webpack_public_path__ + "static/media/page-banner.a8488d3a.jpg";